import { BaseModel } from "model/BaseModel";
import Acao from "./Acao";
import PerfilItemDashboard from "model/dashboard/PerfilItemDashboard";

export default class Perfil implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    descricao: string;
    acoes: Array<Acao>;
    itensDashboard: Array<PerfilItemDashboard>;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
        acoes = new Array<Acao>(),
        itensDashboard = new Array<PerfilItemDashboard>()
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.descricao = descricao;
        this.acoes = acoes;
        this.itensDashboard = itensDashboard;
    }
}
